import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import CustomActionPanel from "../actions/CustomActionPanel";
import CustomDrawer from "./CustomDrawer";
import FilterPanel from "../filters/FilterPanel";
import "./style.scss";
import { convertToDateRange, convertToDates } from "../../utils/commonUtils";
import { handleExport } from "../../redux/service/modules/exportToExcel";
const defualtPanelState = { main: true, filter: false };

const FilterableContentPanel = ({
    title,
    filterableElm: FilterableElm,
    closeDrawer,
    filtersContent,
    isPanelOpen,
    initialDateRange,
    isShowDateRangeFilter,
    isShowFilters,
    range,
    exportToExcelQuery
}) => {
    const [panelsOpen, setPanelsOpen] = useState({ ...defualtPanelState });
    const [filterDetails, setFilterDetails] = useState({
        appliedFilters: {},
        filterCount: 0,
        rawFilters: {},
    });
    const [dateRange, setDateRange] = useState({});

    useEffect(() => {
        if (initialDateRange) {
            setDateRange(convertToDateRange(initialDateRange));
        }
    }, [initialDateRange]);

    const handleDateRangeChange = useCallback((startDate, endDate) => {
        setDateRange({ startDate, endDate });
    }, []);

    const handlePanelClose = (panel) => {
        if (panel === "filter") {
            setPanelsOpen({ ...defualtPanelState });
        } else {
            closeDrawer();
            setPanelsOpen({ ...defualtPanelState });
        }
    };

    const exportToExcel = () => {
        handleExport(exportToExcelQuery, {appliedFilters: filterDetails.appliedFilters, ...(dateRange) || {}})
    }
    return (
        <CustomDrawer open={isPanelOpen}>
            <Box sx={styles.box}>
                {panelsOpen.main && (
                    <Box
                        sx={{
                            maxWidth: panelsOpen.filter
                                ? "calc(100% - 350px)"
                                : "100%",
                            minWidth: "800px",
                            padding: "1px 5px",
                        }}
                    >
                        <CustomActionPanel
                            header={title}
                            onClose={() => handlePanelClose("main")}
                            isShowDateRange={isShowDateRangeFilter}
                            isShowFilters={isShowFilters}
                            filterCta={() =>
                                setPanelsOpen((prev) => ({
                                    ...prev,
                                    filter: true,
                                }))
                            }
                            range={range}
                            dateRange={dateRange}
                            handleDateRangeChange={handleDateRangeChange}
                            filtersCount={filterDetails.filterCount}
                            exportToExcel={exportToExcel}
                            displayExportToExcel = {!!exportToExcelQuery}
                        >
                            <FilterableElm
                                appliedFilters={filterDetails.appliedFilters}
                                filterElmDateRange={convertToDates(dateRange)}
                            />
                        </CustomActionPanel>
                    </Box>
                )}
                {panelsOpen.filter && (
                    <FilterPanel
                        filtersContent={filtersContent}
                        handlePanelClose={() => handlePanelClose("filter")}
                        appliedFilters={filterDetails.rawFilters}
                        isFilterableContentPanel={true}
                        onApply={(
                            transformedFilters,
                            filterCount,
                            rawFilters
                        ) => {
                            setFilterDetails({
                                appliedFilters: transformedFilters,
                                filterCount,
                                rawFilters,
                            });
                        }}
                    />
                )}
            </Box>
        </CustomDrawer>
    );
};

const styles = {
    paper: {
        height: "100vh",
        p: 3,
        bgcolor: "#F9FAFB",
    },
    box: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        height: "100%",
        bgcolor: "white",
        width: "100%",
        transition: "width 0.3s ease-in-out",
    },
    text: {
        color: "#939598",
    },
    filterBox: {
        maxWidth: "30%",
    },
};

FilterableContentPanel.propTypes = {
    filtersContent: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    closeDrawer: PropTypes.func.isRequired,
    isShowDateRangeFilter: PropTypes.bool,
    isShowFilters: PropTypes.bool,
};

export default FilterableContentPanel;
